export default __webpack_public_path__ + "static/media/sentEmail.9506a02e.svg";